import React from 'react';
import IDHelpers from '../../../../../core/helpers/IDHelper';
import Spinner from '@/presentation/components/Spinner';
import GoogleAnalytics from '@/presentation/hooks/useGoogleAnalytics';
import { CATEGORIES } from '../../constants';
import { CardButtonEvent } from './CardButtonEvent';

interface EventCategoriesProps {
  dataEvents: any[];
  selectEvent: (eventId: number, typeEvent: string) => void;
  loading?: boolean;
  isLoading?: boolean;
  hasAction?: boolean;
  tabTitle?: string;
  isSanctioned: boolean;
  eventType: string;
}
const EventCategories = React.memo((props: EventCategoriesProps) => {
  const {
    dataEvents,
    selectEvent,
    loading,
    isLoading,
    hasAction,
    tabTitle,
    isSanctioned,
    eventType
  } = props;

  const googleAnalyticsCardEvents = (event: string) => {
    // eslint-disable-next-line default-case
    switch (event) {
      case 'Talleres':
        GoogleAnalytics.writeLog(
          'portal-services-cardEventWorkshops',
          'services'
        );
        break;
      case 'Conferencias':
        GoogleAnalytics.writeLog(
          'portal-services-cardEventConferences',
          'services'
        );
        break;
      case 'Actividades':
        GoogleAnalytics.writeLog(
          'portal-services-cardEventActivies',
          'services'
        );
        break;
      case 'Inscritos':
        GoogleAnalytics.writeLog(
          'portal-services-cardEventFeatured',
          'services'
        );
        break;
    }
  };

  return (
    <>
      {hasAction && dataEvents && dataEvents.length !== 0 && (
        <p
          style={{
            fontWeight: 400,
            fontSize: '16px',
            lineHeight: '24px',
            padding: '16px 0 16px 0'
          }}
        >
          {dataEvents.length} resultado(s) para tu búsqueda
        </p>
      )}
      {!hasAction && dataEvents && dataEvents.length !== 0 && (
        <p
          style={{
            fontWeight: 700,
            fontSize: '16px',
            lineHeight: '24px',
            padding: '17px 0 12px 0',
            color: '#161D1F'
          }}
        >
          {tabTitle === 'Inscritos' ? (
            'Eventos destacados'
          ) : (
            <>
              {tabTitle === 'Talleres'
                ? `Tenemos estos ${tabTitle?.toLowerCase()} para ti`
                : `Tenemos estas ${tabTitle?.toLowerCase()} para ti`}
            </>
          )}
        </p>
      )}

      {isLoading || loading ? (
        eventType !== 'inscritos' && <Spinner />
      ) : (
        <div className="gridCardEvent">
          {dataEvents?.map((event: any) => (
            <CardButtonEvent
              key={IDHelpers.generateID()}
              event={event}
              selectEvent={() => {
                googleAnalyticsCardEvents(tabTitle ?? '');
                selectEvent(
                  event.idEvent,
                  CATEGORIES[Number(event.eventType.id)]
                );
              }}
              isSanctioned={isSanctioned}
            />
          ))}
        </div>
      )}
    </>
  );
});
export default EventCategories;
